import { FormItemProps } from "antd";
import { currencyToNumber } from "../../utils";
import {
  MaskInput,
  NumberInput,
  TextInput,
  SelectInput,
  SelectMultipleInput,
  MaskCpfCnpjInput,
} from "../inputs";
import {
  validationFieldRequired,
  validationDate,
  validationNumberFieldPositive,
} from "../../utils/formValidations";

interface FormItemParams extends FormItemProps {
  name: string;
  span?: number;
  disabled?: boolean;
  options?: any;
  placeholder?: string;
  onChange?: (changed: any, values: any) => any;
  hide?: ((data: any) => boolean) | boolean;
  onBlur?: any;
}

interface NumberFormItemParams extends FormItemParams {
  prefix?: string;
  decimalScale?: number;
  allowNegative?: boolean;
}

interface MaskFormItemParams extends FormItemParams {
  mask?: string;
}

interface SelectFormItemParams extends FormItemParams {
  options?: { label: string; value: any; disabled?: boolean }[];
  renderItem?: any;
  defaultValue?: any;
}

export const MaskFormItem = ({
  mask,
  placeholder,
  disabled,
  ...rest
}: MaskFormItemParams) => ({
  ...rest,
  input: MaskInput({
    mask,
    placeholder,
    disabled,
    ...rest,
  }),
});

export const MaskCpfCnpjFormItem = ({
  mask,
  placeholder,
  disabled,
  ...rest
}: MaskFormItemParams) => ({
  ...rest,
  input: MaskCpfCnpjInput({
    mask,
    placeholder,
    disabled,
    ...rest,
  }),
});

export const DateFormItem = ({
  rules,
  placeholder,
  disabled,
  mask,
  ...rest
}: MaskFormItemParams) => ({
  ...rest,
  rules: rules ? rules : validationDate,
  input: MaskInput({
    mask: mask ?? "99/99/9999",
    placeholder: placeholder || "01/01/2021",
    disabled,
  }),
});

export const TextFormItem = ({
  rules,
  placeholder,
  disabled,
  ...rest
}: FormItemParams) => ({
  ...rest,
  rules: rules || [],
  input: TextInput({ placeholder, disabled, ...rest }),
});

export const SelectFormItem = ({
  placeholder,
  disabled,
  options,
  rules,
  ...rest
}: SelectFormItemParams) => ({
  ...rest,
  rules: rules ?? validationFieldRequired,
  input: SelectInput({ placeholder, disabled, options, ...rest }),
});

export const SelectMultipleFormItem = ({
  placeholder,
  disabled,
  options,
  rules,
  assessoresSelected,
  handleChangeAssessores,
  professionals,
  ...rest
}: any) => ({
  ...rest,
  input: SelectMultipleInput({
    placeholder,
    disabled,
    options,
    assessoresSelected,
    handleChangeAssessores,
    professionals,
  }),
});

export const NumberFormItem = ({
  name,
  label,
  rules = [],
  prefix = "",
  disabled = false,
  placeholder = "",
  decimalScale = 2,
  allowNegative = false,
  onChange,
}: NumberFormItemParams) => ({
  name,
  label,
  rules,
  placeholder,
  input: NumberInput({
    prefix,
    decimalScale,
    placeholder,
    allowNegative,
    disabled,
  }),
  onChange: onChange
    ? onChange
    : (changed: any, values: any) =>
        changed[name]
          ? Number(changed[name].replace(/\./g, "").replace(",", ".")) || 0
          : values[name],
});

export const CurrencyFormItem = ({
  name,
  label,
  rules = [],
  prefix = "R$ ",
  disabled = false,
  decimalScale = 2,
  placeholder = "R$ 0,00",
  allowNegative = false,
  onChange,
  ...rest
}: NumberFormItemParams) => ({
  ...rest,
  name,
  label,
  placeholder,
  rules: rules ? rules : validationNumberFieldPositive,
  input: NumberInput({
    prefix,
    decimalScale,
    placeholder,
    allowNegative,
    disabled,
  }),
  onChange: onChange
    ? onChange
    : (changed: any, values: any) =>
        changed[name] ? currencyToNumber(changed[name], prefix) : values[name],
});
